import { Clipboard } from '@angular/cdk/clipboard';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';

import { UserLinksService } from 'src/app/services/user-links/user-links.service';
import { UserLinksStore } from 'src/app/stores/user-links.store';

@Component({
  selector: 'app-user-links',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  templateUrl: './user-links.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-links.component.scss',
})
export class UserLinksComponent implements OnInit {
  private readonly _clipboard = inject(Clipboard);
  private readonly _userLinksService = inject(UserLinksService);
  private readonly _toastr = inject(ToastrService);
  readonly userLinksStore = inject(UserLinksStore);

  expandedLinkId: string | null = null;

  ngOnInit(): void {
    if (this.userLinksStore.status() !== 'success') {
      this._userLinksService.fetchUserLinks().subscribe({
        error: () => {
          // Store already holds error state; optional logging can go here.
        },
      });
    }
  }

  copyLinkUrl(url: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this._clipboard.copy(url);
    this._toastr.success('Successfully copied URL!');
  }

  toggleUrlVisibility(linkId: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.expandedLinkId = this.expandedLinkId === linkId ? null : linkId;
  }
}
